 <template>
  <div class="content-table">
    <div class="content-row top-title">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>商品详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content-row">
      <div class="col-5">
        <div class="demo-image__preview" style="height: 350px;">
          <el-image
            v-if="good_info.pic!=''&&good_info.pic!=null"
            class
            :src="good_info.pic"
            style="height: 350px;"
          ></el-image>
          <el-image v-else class src="static/image/error.png" style="height: 350px;"></el-image>
          <!-- <el-image class :src="good_info.pic"></el-image> -->
        </div>
        <div class="col-12" style="display:flex;width:90%;margin:0">
          <div
            class="demo-image__preview1"
            style="width:18%;margin-right:2%;"
            v-for="(item,index) in good_info.pic_else"
            :key="index"
          >
            <el-image
              v-if="item!=''&&item!=null"
              :src="item"
              @click="replace_img(index)"
              style="height:93px;display: inline-block;width:100%;border: 2px solid #ccc;"
            ></el-image>
            <el-image
              class
              v-else
              src="static/image/error.png"
              style="height:93px;display: inline-block;width: 100%;border: 2px solid #ccc;"
            ></el-image>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div>
          <span class="span-title">{{good_info.good_name}}</span> |
          <span>{{good_info.brand_id}}</span>
        </div>
        <div class="good-content" style="white-space: pre;">{{good_info.good_spec}}</div>
        <div class="good-content">
          <div class="left-title">产 地:</div>
          <div class="right-content">{{good_info.product_area}}</div>
        </div>
        <div class="good-content">
          <div class="left-title">价 格:</div>
          <div class="right-content">
            <span class="span-money price-money">￥ {{good_info.dis_price}}</span>
            <span v-if="good_info.is_promo==1">￥ {{good_info.sale_price}}</span>
          </div>
        </div>
        <div class="good-content">
          <div class="left-title">仓 库:</div>
          <div class="right-content">
            <ul class="color-menu">
              <li
                v-for="(item,index) in good_info.ware"
                class="color-li"
                @click="checkColor(item,$event,i)"
                :key="index"
              >{{item.wareInfo.name}}</li>
            </ul>
          </div>
        </div>
        <div class="good-content">
          <div class="left-title">整箱数:</div>
          <div class="right-content">{{good_info.good_pcs}}</div>
        </div>
        <div class="good-content">
          <div class="left-title">库存量:</div>
          <div class="right-content">
            <span class="span-money">{{stork_count}}</span>
          </div>
        </div>
        <div class="good-content">
          <div class="left-title">数量:</div>
          <div class="right-content">
            <template>
              <el-input-number size="small" v-model="num" :min="min_num" label="描述文字"></el-input-number>
            </template>
          </div>
        </div>

        <div class="good-content" style="margin-top: 30px;">
          <el-button type="primary" size="medium" @click="gotoCustomized()" plain>立即购买</el-button>
          <el-button type="danger" @click="addToCart()" plain size="medium">
            <i class="fa fa-shopping-cart button-icon" aria-hidden="true"></i>加入购物车
          </el-button>
          <el-button
            type="warning"
            size="medium"
            plain
            @click="collectionGood(good_info.collect , good_info.good_itemid)"
          >
            <i class="fa fa-heart button-icon" plain aria-hidden="true"></i>
            {{good_info_data.collect == 1 ? '已收藏' : '收藏'}}
          </el-button>
          <el-button size="medium" @click="goback()">返回</el-button>
          <!-- <el-button :type="good_info_data.collect == 1 ? 'primary' : 'button'" size="medium" plain @click="collectionGood(good_info_data.collect,good_info_data.good_erpid)">
            <i class="fa fa-heart button-icon" plain aria-hidden="true"></i>{{good_info_data.collect == 1 ? '已收藏' : '收藏'}}
          </el-button>
          <el-button type="danger" @click="addToCart()" plain size="medium">
            <i class="fa fa-shopping-cart button-icon" aria-hidden="true"></i>加入购物车
          </el-button>
          <transition
            v-on:before-enter="beforeEnter"
            v-on:enter="enter"
            v-on:after-enter="afterEnter"
          >
            <img class="add_img_js" v-if="addShow" src="/index/static/image/good.jpg" alt />
          </transition>
          <el-button
            type="primary"
            size="medium"
            v-if="good_info_data.made == 1"
            @click="gotoCustomized(good_info_data.cate_id1,good_info_data.good_erpid)"
            plain
          >可定制</el-button>-->
        </div>
      </div>
    </div>
    <div class="content-row bottom-row">
<!--      <div class="col-2">-->
<!--        <div class="left-boxshadow">-->
<!--          <span class="span-title-recommed">产品推荐</span>-->
<!--          <el-divider style="margin: 5px 0;"></el-divider>-->
<!--          <ul class="recommend-menu">-->
<!--             <li v-for="(item,index) in good_recommon"  :key="index">-->
<!--               <div class="content-row pointer content-left-list">-->
<!--                 <div class="content-left-list-item">-->
<!--                   <div class="demo-image__preview" @click="buyGood(item.good_itemid)">-->
<!--                     <el-image class="recommend-img" :src="item.pic"></el-image>-->
<!--                   </div>-->
<!--                 </div>-->
<!--                 <div class="content-left-list-item content-left-list-item1">-->
<!--                   <div class="content-row recommon-good">-->
<!--                     &lt;!&ndash; style="text-overflow:ellipsis;white-space:nowrap;overflow:hidden;" &ndash;&gt;-->
<!--                     <div-->
<!--                       class="span-name outer"-->
<!--                       :title="item.good_spec"-->
<!--                       style="width:90%;white-space:pre-wrap"-->
<!--                     >{{item.good_spec}}</div>-->
<!--                     <div-->
<!--                       class="span-name outer"-->
<!--                       :title="item.good_name"-->
<!--                       style="width:90%;white-space:pre-wrap"-->
<!--                     >{{item.good_name}}</div>-->
<!--                   </div>-->
<!--                   <div class="content-row">-->
<!--                     <span class="span-money">￥{{item.sale_price}}</span>-->
<!--                   </div>-->
<!--                 </div>-->
<!--               </div>-->
<!--            </li>-->
<!--          </ul>-->
<!--        </div>-->
<!--      </div>-->
      <div class="col-10">
        <div class="content-row good-detail">
          <span class="span-good-detial">商品详情</span>
        </div>
        <div v-if="content==''||content==null">
          <div style="padding: 20px 30px;color: gray;">暂无详情</div>
        </div>
        <div v-else v-html="content"></div>
      </div>
    </div>
    <div class="col-1 hover-nav-list hover-nav-list1" style="bottom: 1%;height: auto;width: 10%;">
      <div class="left-boxshadow left-boxshadow-list">
        <span class="span-title2">产品推荐</span>
        <ul class="recommend-menu">
          <li v-for="(item,index) in good_recommon" :key="index">
            <div class="content-row pointer content-left-list">
              <div class="content-left-list-item">
                <div class="demo-image__preview" @click="buyGood(item.good_itemid)">
                  <el-image class="recommend-img" :src="item.pic"></el-image>
                </div>
              </div>
              <div class="content-left-list-item content-left-list-item1">
                <div class="content-row recommon-good">
                  <!-- style="text-overflow:ellipsis;white-space:nowrap;overflow:hidden;" -->
                  <div
                    class="span-name outer"
                    :title="item.good_spec"
                    style="width:90%;white-space:pre-wrap"
                  >{{item.good_spec}}</div>
                  <div
                    class="span-name outer"
                    :title="item.good_name"
                    style="width:90%;white-space:pre-wrap"
                  >{{item.good_name}}</div>
                </div>
                <div class="content-row">
                  <span class="span-money2">￥{{item.sale_price}}</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="hover-nav-list hover-nav-list2">
      <el-popover
        placement="left-start"
        style="color:red"
        width="200"
        trigger="hover">
        <div class="left-boxshadow left-boxshadow-list">
          <span class="span-title">产品推荐</span>
          <ul class="recommend-menu">
            <li v-for="(item,index) in good_recommon" :key="index">
              <div class="content-row pointer content-left-list">
                <div class="content-left-list-item">
                  <div class="demo-image__preview" @click="buyGood(item.good_itemid)">
                    <el-image class="recommend-img" :src="item.pic"></el-image>
                  </div>
                </div>
                <div class="content-left-list-item content-left-list-item1">
                  <div class="content-row recommon-good">
                    <div
                      class="span-name outer"
                      :title="item.good_spec"
                      style="width:90%;white-space:pre-wrap"
                    >{{item.good_spec}}</div>
                    <div
                      class="span-name outer"
                      :title="item.good_name"
                      style="width:90%;white-space:pre-wrap"
                    >{{item.good_name}}</div>
                  </div>
                  <div class="content-row">
                    <span class="span-money">￥{{item.sale_price}}</span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <el-button slot="reference" type="primary" class="btn_gg" size="small" icon="el-icon-s-promotion" circle></el-button>
      </el-popover>
    </div>
  </div>
</template>　
<script>
import { debuglog } from "util";
// var id = this.$route.query.id;
export default {
  name: "Good",
  components: {},
  // beforeRouteEnter(to,from,next){
  //   next(vm => {
  //     console.log(to);
  //     console.log(from);
  //     vm.view();
  //   });
  //
  // },
  data() {
    return {
      data: [],
      good_info: [], //商品信息
      stork_count: "", //库存量
      stork_id: "",
      temp_i: 0,
      num: 1,
      min_num: 1,
      content: "",
      good_info_data:[],
      good_recommon:[]
    };
  },
  watch: {
    $route(to, from) {
      this.view();
      // 对路由变化作出响应...
    }
  },
  mounted() {
    this.view();
  },
  methods: {
    view() {
      this.$axios({
        method: "post",
        url: "/index/good/info",
        params: {
          id: this.$route.query.id
        }
      })
        .then(res => {
          this.good_info = res.data.data.data[0];
          if (this.good_info.mini_qty != null) {
            this.min_num = this.good_info.mini_qty;
            this.num = this.good_info.mini_qty;
          }
          this.stork_count = parseInt(res.data.data.data[0].ware[0].qty);
          this.checkedColor = res.data.data.data[0].ware[0];
          this.stork_id = res.data.data.data[0].ware[0].ware_id;
          this.content = res.data.data.data[0].content;
          setTimeout(() => {
            $(".color-li").removeClass("active");
            $(".default-active ul")
              .find("li:eq(" + this.temp_i + ")")
              .addClass("active");
          }, 1000);
        })
        .catch(err => {});

      //请求商品推荐
      this.$axios({
        method: "post",
        url: "/index/good/good_recommend",
        params: {
          cate_id: 0,
          pagesize: 7
        }
      })
        .then(res => {
          this.good_recommon = res.data.data.data;
          console.log(this.good_recommon);
        })
        .catch(err => {});
    },
    buyGood(good_id) {
      if (good_id != "") {
        this.$router.push({
          path: "/GoodDetail/index",
          query: { id: good_id }
        });
      }
    },
    addToCart() {
      if (this.$store.state.currentUser == "") {
        this.$message1("当前未登录，请登录！");
        return;
      }
      if (this.stork_id == "") {
        this.$message1("请选择仓库!");
        return;
      }
      if (this.stork_count < this.num) {
        this.$message1("库存不足!");
        return;
      }
      this.$axios({
        method: "post",
        url: "/index/cart/add_cart",
        params: {
          good_itemid: this.$route.query.id,
          qty: this.num,
          ware_id: this.stork_id
        }
      })
        .then(res => {
          if (res.data.status == "ok") {
            this.$message("加入购物车成功!");

            this.$axios({
              method: "post",
              url: "/index/cart/get_qty"
            })
              .then(res => {
                this.$store.dispatch("setQty", res.data.data);
                sessionStorage.setItem(
                  "qty",
                  this.$store.getters.getcurrentQty
                );
              })
              .catch(err => {});
            setTimeout(() => {
              this.view();
            }, 300);
          }
        })
        .catch(err => {});
    },
    // 进入中
    enter(el, done) {},
    // 进入后
    afterEnter() {
      // this.addShow1 = false;
    },
    checkColor(item, event, i) {
      this.temp_i = i;
      $(".color-li").removeClass("active");
      event.currentTarget.classList.add("active");
      this.stork_count = item.qty;
      this.stork_id = item.ware_id;
      this.checkedColor = item;
      // if (
      //   this.good_info_attr.lengths.length == 0 ||
      //   this.good_info_attr.lengths == null
      // ) {
      //   this.$axios({
      //     method: "post",
      //     url: "/index/catalogue/check_good",
      //     params: {
      //       good_id: this.$route.query.id,
      //       color: this.checkedColor,
      //       length: this.checkedLength
      //     }
      //   })
      //     .then(res => {
      //       if (res.data.status != "ok") {
      //         this.$message1(res.data.msg);
      //         this.price = '0.00';
      //       } else {
      //         this.good_code = res.data.data.sku_good_code;
      //         this.price = res.data.data.price;
      //       }
      //     })
      //     .catch(err => {
      //       // this.$message(res.data.msg);
      //     });
      // }
    },
    checkLength(item, event) {
      // $(".length-li").removeClass("active");
      // event.currentTarget.classList.add("active");
      // this.checkedLength = item;
      // if ($(".color-li.active").length > 0) {
      //   this.$axios({
      //     method: "post",
      //     url: "/index/catalogue/check_good",
      //     params: {
      //       good_id: this.$route.query.id,
      //       color: this.checkedColor,
      //       length: this.checkedLength
      //     }
      //   })
      //     .then(res => {
      //       debugger;
      //       if (res.data.status != "ok") {
      //         this.$message1(res.data.msg);
      //         this.price = '0.00';
      //       } else {
      //         this.good_code = res.data.data.sku_good_code;
      //         this.price = res.data.data.price;
      //       }
      //     })
      //     .catch(err => {
      //       // this.$message(res.data.msg);
      //     });
      // }
    },
    switchLength() {
      // this.checkedLength = this.length;
      // $(".length-li").removeClass("active");
    },
    gotoCustomized() {
      if (this.$store.state.currentUser == "") {
        this.$message1("当前未登录，请登录！");
        return;
      }
      if (this.stork_count < this.num) {
        this.$message1("库存不足！");
        return;
      }
      if (this.num <= 0) {
        this.$message1("请填写正确数量！");
        return
      }
      var data = [];
      var buy = [];
      data.push({
        goods_erpid: this.$route.query.id,
        qty: this.num,
        ware_id: this.checkedColor.ware_id
      });
      buy.push({
        good_id: this.$route.query.id,
        qty: this.num,
        ware_id: this.checkedColor.ware_id
      });
      sessionStorage.setItem("detail_data", JSON.stringify(data));
      sessionStorage.setItem("buy", JSON.stringify(buy));
      this.$router.push({
        path: "/Cart/order",
        // query: { cate_id: this.$route.query.cate_id, cate_id1: cate_id1 ,good_erpid:good_erpid}
        query: { type: 1 }
      });
    },
    goback() {
      window.history.back(-1);
    },
    replace_img(i) {
      this.good_info.pic = this.good_info.pic_else[i];
    },
    collectionGood(collect, good_erpid) {
      // if (collect == 1) {
      //   this.$axios({
      //     method: "post",
      //     url: "/index/collection/del",
      //     params: {
      //       good_erpid: good_erpid
      //     }
      //   })
      //     .then(res => {
      //       if (res.data.status == "ok") {
      //         this.$message1("取消收藏成功!");
      //         this.good_info.data.collect = 0;
      //       }
      //     })
      //     .catch(err => {
      //       // this.$message(res.data.msg);
      //     });
      // } else {
      this.$axios({
        method: "post",
        url: "/index/collection/create",
        params: {
          id: good_erpid
        }
      })
        .then(res => {
          if (res.data.status == "ok") {
            this.$message1(res.data.msg);
            this.good_info.data.collect = 1;
          }
        })
        .catch(err => {
          // this.$message(res.data.msg);
        });
      // }
    }
  }
};
</script>
<style lang="less" scoped>
.top-title {
  margin-top: 1%;
}
.cu_span {
  width: 20%;
  height: 100%;
  border: 3px solid #f4770f;
  color: #f4770f;
  font-size: 14px;
  font-weight: 600;
  border-radius: 30px;
  padding: 5px 15px 5px 15px;
  cursor: pointer;
}
.cate-menu {
  width: 100%;
  background-color: #2d8de4;
  float: left;
  height: 40px;
  line-height: 40px;
  padding-left: 0;
  margin-bottom: 2.5%;
}
.cate-menu li {
  float: left;
  width: auto;
  list-style-type: none;
  margin: 0 2% 0 0;
  color: #fff;
  height: 100%;
  padding-left: 2%;
  cursor: pointer;
}
.active {
  right: 0;
  bottom: 0;
  background-image: url(/static/icon/active.png);
  background-position: bottom;
  background-repeat: no-repeat;
  background-position-x: right;
  display: block;
  color: black;
}
.cate-list-detail {
  float: left;
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding-left: 0;
  position: absolute;
  cursor: pointer;
}
.cate-list-detail li {
  list-style-type: none;
  width: auto;
  margin: 0 4% 0 0;
  height: 100%;
  padding-left: 0;
  color: darkgray;
  cursor: pointer;
}
.recommend-img {
  width: 60px;
  height: 60px;
  float: left;
}
.recommend-menu {
  float: left;
  padding: 0;
  margin: 0;
  width: 100%;
}
.recommend-menu span {
  float: left;
}
.recommend-menu li {
  float: left;
  list-style-type: none;
  width: 100%;
  border-bottom: 1px solid lightgray;
  font-size: 14px;
}
.attr-menu {
  float: left;
  width: 15%;
  height: 100%;
  line-height: 40px;
  padding-left: 0;
}
.attr-menu li {
  list-style-type: none;
  width: 100%;
  margin: 0 4% 0 0;
  height: 100%;
  padding-left: 20px;
  background-color: #f8efe7;
  cursor: pointer;
  border: 1px solid lightgrey;
  text-align: left;
}
.attr-list-detail {
  float: left;
  width: 90%;
  height: 40px;
  line-height: 40px;
  position: absolute;
  margin-left: 8%;
  margin-top: -3.5%;
}
.col-1 {
  width: 10%;
  text-align: left;
  box-shadow: 1px 1px 8px lightgrey;
}
.attr-list-detail li {
  list-style-type: none;
  width: auto;
  margin: 0 4% 0 1%;
  height: 100%;
  padding-left: 0;
  color: darkgray;
  cursor: pointer;
}
.hide {
  display: none;
}
.has-gutter {
  display: none;
}
.el-table__header-wrapper {
  display: none;
}
.span-attr-value {
  margin: 0 2% 0 1%;
}
.fillter-menu {
  width: 100%;
  float: left;
  background-color: whitesmoke;
  padding: 0;
}
.fillter-menu span {
  float: left;
}
.fillter-menu li {
  float: left;
  line-height: 40px;
  list-style-type: none;
  margin: 0 2% 0 1%;
}
.el-icon-d-caret {
  cursor: pointer;
}
.input-price {
  width: 45%;
  float: left;
}
.el-input__inner {
  height: 30px;
  width: 70%;
}
.add_img_js {
  display: none;
}
.col-5 .demo-image__preview {
  height: 80%;
  border: 1px dashed #ccc;
  width: 90%;
  margin-top: 2%;
}
.col-5 .demo-image__preview .el-image {
  width: 100%;
  height: 100%;
}
.col-5 .demo-image__preview1 {
  height: 80%;
  width: 90%;
  margin-top: 2%;
}
.col-5 .demo-image__preview1 .el-image {
  width: 100%;
  height: 100%;
}
.span-name {
  font-size: 14px;
  color: #7c7c7c;
  word-break: break-all;
}
.span-money {
  color: #d1945d;
  font-weight: 600;
  line-height: 1.5;
  margin-right: 1%;
}
.span-money2 {
  color: #c91815;
  font-weight: 600;
}
.dpan-cout {
  font-size: 14px;
  color: #666666;
  line-height: 1.5;
  margin-right: 1%;
}
.price-money {
  font-size: 20px;
  color: #ff0000;
}
.col-2 {
  box-shadow: 0px 0px 10px lightgrey;
  margin-right: 1%;
  cursor: pointer;
}
.col-10 {
  width: 100%;
  box-shadow: 0px 5px 5px #e8ebef;
}
.col-2,
.col-5,
.content-row {
  text-align: left;
}
.color-menu,
.length-menu {
  width: 100%;
  float: left;
  padding: 0;
  margin: 0;
}
.color-menu {
  display: flex;
  align-items: center;
  height: 100%;
  flex-wrap: wrap;
}
.color-menu li,
.length-menu li {
  float: left;
  list-style-type: none;
  // width: 25%;
  padding: 0px 5px;
  border: 1px solid #c39a58;
  margin: 0 3% 1% 0;
  text-align: center;
  height: 1.5rem;
  line-height: 1.5rem;
  cursor: pointer;
  font-size: 14px;
}
.height_3rem {
  height: 2.5rem;
}
.button-icon {
  margin-right: 5%;
}
.span-title {
  font-size: 18px;
  font-weight: 600;
}
.span-title-recommed {
  color: #2d8de4;
  margin: 5%;
  font-size: 15px;
  display: inline-block;
}
/*.col-1 {*/
/*  color: #7c7c7c;*/
/*  width: 80px !important;*/
/*}*/
.col-6 {
  margin-top: 2%;
}
.good-detail {
  background-color: whitesmoke;
  // box-shadow: 0px 0px 5px lightgray inset;
  height: 2rem;
}
.span-good-detial {
  background-color: #cf955d;
  color: #fff;
  height: 100%;
  width: 10%;
  float: left;
  line-height: 2rem;
  text-align: center;
}
.bottom-row {
  margin-top: 4%;
}
.back-top-div {
  height: 100%;
  width: 100%;
  background-color: #f2f5f6;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
  text-align: center;
  line-height: 40px;
  color: #1989fa;
}
.circle {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: aquamarine;
}
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.5s ease-out;
}
.slide-fade-enter,
.slide-fade-leave-to {
  /* transform: translateX(500px); */
  opacity: 0;
}
.bigimg {
  width: 300px;
}

.img-fade-enter-active {
  transition: all 1s ease-out;
}
.img-fade-enter {
  transform: scale(0.5);
  /* width: 50px; */
}

.shop_cart {
  padding: 20px;
}
.shop_cart .add {
  position: relative;
  margin-top: 100px;
  width: 500px;
  display: inline-block;
}
.shop_cart .add button {
  position: absolute;
  z-index: 99;
}
.shop_cart .cart {
  width: 300px;
  display: inline-block;
}
.shop_cart .cart img {
  width: 100%;
}
.shop_cart .add_img {
  width: 100px;
  position: absolute;
  left: 600px;
  top: -160px;
}
.shop_cart-enter-active {
  transition: all 1s ease-out;
}
.shop_cart-enter {
  opacity: 0;
  transform: scale(0.5);
  transform: translate(-610px, 100px);
}
.price-price-size {
  background: #f6f6f6;
  line-height: 2.5rem;
}
.lin-height_3rem {
  line-height: 2.5rem;
}
.flex-content-das {
  display: flex;
  margin-top: 1%;
}
.flex-content-das-item {
  width: 14%;
}
.flex-content-das-item1 {
  flex: 1;
}
.el-button--primary.is-plain {
  background: #161616;
  color: #fff;
}
.el-button--danger.is-plain {
  background: #cdaa73;
  color: #fff;
}
.el-button--danger.is-plain:focus,
.el-button--danger.is-plain:hover {
  border-color: #cdaa73;
}
.good-content {
  display: flex;
  height: 35px;
  line-height: 35px;
}
.left-title {
  min-width: 60px;
  width: 10%;
}
.right-content {
  width: 90%;
}
.content-left-list {
  display: flex;
}
.content-left-list-item {
  flex: 1;
  padding: 2%;
}
.content-left-list-item1 {
  flex: 2;
  padding-left: 1%;
}
.content-left-list-item1 .content-row {
  text-align: left;
}
  .el-divider--horizontal{
    margin: 5px 0;
  }

.hover-nav-list {
  position: fixed;
  /*top: 40%;*/
  bottom: 1%;
  left: 0.5%;
}
.left-boxshadow-list {
  background-color: #fff;
  width: 100%;
}
.left-boxshadow{
  /*width: 10%;*/
  text-align: left;
  -webkit-box-shadow: 1px 1px 8px lightgrey;
  box-shadow: 1px 1px 8px lightgrey;
}

.span-title2 {
  color: #c39a58;
  margin: 5%;
  font-size: 15px;
  display: inline-block;
  width: 90%;
}
/*.content-left-list {*/
/*  display: flex;*/
/*}*/
/*.content-left-list-item {*/
/*  flex: 1;*/
/*  padding: 2%;*/
/*}*/
/*.content-left-list-item1 {*/
/*  flex: 2;*/
/*  padding-left: 1%;*/
/*}*/
/*.content-left-list-item1 .content-row {*/
/*  text-align: left;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/components/GoodDetail/index.vue